// API Configuration
// This file handles the base URL for API calls based on the environment

const getApiBaseUrl = () => {
  // Check if we're in development mode (using localhost)
  const isDevelopment = window.location.hostname === 'localhost' || 
                        window.location.hostname === '127.0.0.1';
  
  // Production backend URL
  const productionApiUrl = 'https://bixbite.ai';
  
  // Development backend URL (local proxy)
  const developmentApiUrl = '';
  
  return isDevelopment ? developmentApiUrl : productionApiUrl;
};

export const API_BASE_URL = getApiBaseUrl();

// Helper function to build full API endpoint URLs
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return API_BASE_URL ? `${API_BASE_URL}/${cleanEndpoint}` : `/${cleanEndpoint}`;
};

